import { Observer } from "mobx-react-lite";
import React, { useEffect, useRef } from "react";
import joinClassName from "../../utils/className.utils";
import { renderRenderable } from "../../utils/components.utils";
import { setCSSCustomProperty } from "../../utils/css.utils";
import addListener from "../../utils/eventListener.utils";
import './AppPageHeader.scss';
var AppPageHeader = function (props) {
    var el = useRef(null);
    function checkSize() {
        var _a;
        var height = el.current ? el.current.clientHeight : 0;
        var parent = (_a = el.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (parent === null || parent === void 0 ? void 0 : parent.classList.contains('CustomScrollbar')) {
            parent = parent.parentElement;
        }
        setCSSCustomProperty('--AppPageHeaderHeight', height + 'px', parent !== null && parent !== void 0 ? parent : void 0);
    }
    useEffect(function () {
        function handleWindowResize() {
            checkSize();
        }
        handleWindowResize();
        var cleanUpListeners = addListener(window, 'resize focus blur', handleWindowResize);
        return function () {
            cleanUpListeners();
        };
    }, []);
    useEffect(function () {
        checkSize();
    });
    return React.createElement(Observer, { children: function () { return (React.createElement("header", { ref: el, className: joinClassName('AppPageHeader', props.className, props.spaceChildren && 'spaceChildren', props.transparent && 'transparent'), "data-primary-color": props.cssPrimaryColor },
            React.createElement("div", { className: "AppPageHeaderInner" },
                React.createElement("div", { className: "AppPageHeaderInnerContent" },
                    props.startSlot && (React.createElement("span", { className: "AppPageHeaderSlot start", children: renderRenderable(props.startSlot) })),
                    React.createElement("div", { className: "AppPageHeaderSlotInner" },
                        props.beforeTitle && React.createElement("div", { className: "AppPageBeforeTitle" }, renderRenderable(props.beforeTitle)),
                        props.title && React.createElement("h1", { className: "AppPageTitle" }, renderRenderable(props.title)),
                        props.afterTitle && React.createElement("div", { className: "AppPageAfterTitle" }, renderRenderable(props.afterTitle)))),
                props.endSlot && (React.createElement("span", { className: "AppPageHeaderSlot topEnd" }, renderRenderable(props.endSlot))),
                props.children && React.createElement("span", { className: "AppPageHeaderSlot default" }, props.children)))); } });
};
export default AppPageHeader;
